var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:search-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3333 2C9.97785 2.00012 8.64213 2.32436 7.43752 2.94569C6.23291 3.56702 5.19435 4.46742 4.4085 5.57175C3.62264 6.67609 3.11227 7.95235 2.91997 9.29404C2.72767 10.6357 2.85901 12.004 3.30304 13.2846C3.74707 14.5652 4.49091 15.7211 5.4725 16.6557C6.45409 17.5904 7.64497 18.2768 8.94578 18.6576C10.2466 19.0384 11.6196 19.1026 12.9503 18.8449C14.281 18.5872 15.5307 18.015 16.5953 17.176L20.2473 20.828C20.4359 21.0102 20.6885 21.111 20.9507 21.1087C21.2129 21.1064 21.4637 21.0012 21.6491 20.8158C21.8345 20.6304 21.9397 20.3796 21.9419 20.1174C21.9442 19.8552 21.8434 19.6026 21.6613 19.414L18.0093 15.762C18.9973 14.5086 19.6124 13.0024 19.7844 11.4157C19.9563 9.82905 19.6781 8.22602 18.9815 6.79009C18.2849 5.35417 17.1981 4.14336 15.8456 3.29623C14.493 2.44911 12.9292 1.99989 11.3333 2ZM4.83326 10.5C4.83326 8.77609 5.51808 7.12279 6.73707 5.90381C7.95605 4.68482 9.60935 4 11.3333 4C13.0572 4 14.7105 4.68482 15.9295 5.90381C17.1484 7.12279 17.8333 8.77609 17.8333 10.5C17.8333 12.2239 17.1484 13.8772 15.9295 15.0962C14.7105 16.3152 13.0572 17 11.3333 17C9.60935 17 7.95605 16.3152 6.73707 15.0962C5.51808 13.8772 4.83326 12.2239 4.83326 10.5Z",
    fill: "#BEBEBE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLine);
export default __webpack_public_path__ + "static/media/search-line.f54099de1580fd782301e765004d6e99.svg";
export { ForwardRef as ReactComponent };